import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import 'rxjs/add/operator/map';
import * as moment from 'moment';
import { PackingEC } from '../model/PackingEC';
import { FilterUrlService } from './filter-url.service';

@Injectable()
export class PackingEcService {
  url:string = GLOBAL.url+"packings";
  filter:string;

  constructor( private http:HttpClient,private _urlService:FilterUrlService ) {
    this._urlService.filters.subscribe(new_filter => this.filter = new_filter );
  }
  /**
  * Obtiene el listado de 10 elementos.
  * @return listado de clientes o un error.
  */
  public get(){
    return this.http.get(this.url+'?sort=-id').map( res => {
      return res;
    });
  }

  public getDataFiltered(filters){
    let url = this.url+filters;
    return this.http.get(url).map( res => {
        return res;
    });
  }

  /**
  * Obtiene el listado de todos los elementos.
  * @return listado de clientes o un error.
  */
  public getAll(){
    let url = this.url+'?limit=100';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado de todos los packings que esten "en Proceso".
  * @return listado o un error.
  */
  public getIncomePackings(estado){
    let url = this.url+'?sort=--id&packing_status_id='+estado+'&limit=1000';
    return this.http.get(url ).map( res => {
      console.log("PACKINGS SERVICIO: ", res);
      return res;
    });
  }

  public getAllStatusPackings(){
    let url = GLOBAL.url+'packing_status';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado de todos los tipo de packings.
  * @return listado o un error.
  */
  public getTypes(){
    let url = GLOBAL.url+'packing_types?limit=100';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene un PDF.
  * @return url de pdf.
  */
  public getPDF(id:string){
    return GLOBAL.url+'packings/'+id+'/pdf';
  }

  /**
   * Obtiene un archivo Excel
   * @return url del archivo excel.
   */
  public getExcel(){
    return GLOBAL.url+'excel_by_lots';
  }

  /**
  * Envia un POST para almacenar información.
  * @param  prov información a enviar
  * @return      respuesta de la peticion http
  */
  public save(prov:any){
    return this.http.post(this.url, prov)
    .map( data => {
      return data;
    });
  }

  /**
  * Actualiza un elemento en la base de datos
  * @param  url  url del elemento que se actualiza.
  * @param  body ¿?
  * @return      respuesta de la peticion http
  */
  public update(url:string, body){
    return this.http.put(url, body)
    .map( data => {return data;});
  }

  /**
  * Actualiza el estado de un packing
  * @param  url  url del elemento que se actualiza.
  * @param  body ¿?
  * @return      respuesta de la peticion http
  */
  public update2(body,id){
    let url = GLOBAL.url+'packings/'+id;
    return this.http.put(url, body)
    .map( data => {return data;});
  }

  /**
  * Elimina un registro de la base de datos
  * @param  url url del elemento que se elimina
  * @return     respuesta de la peticion http
  */
  public delete(url:string){
    return this.http.delete(url).map( response =>{
      return response;
    });

  }

  /**
  * Transforma una fecha (YYYY-MM-DD 00:00:00) para ser almacenada en una BD.
  * @param  fechas fecha a transformar
  * @return        fecha con el formato (YYYY-MM-DD 00:00:00)
  */
  transformDates(fechas:Date):String{
    let fecha = moment(fechas);
    //2018-02-28 00:00:00
    return (fecha.year()+'-'+(fecha.month()+1)+'-'+fecha.date()+' 00:00:00');
  }

  /**
  * Transforma un objeto a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformData(nc:number,ns:number,nt:number,kc:number,ks:number,kt:number,tipo:number,encargadoempaque:string,linea:number){
    console.log("Cajas totales: ", nt);
    console.log("Kilos Cajas: ", nc);
    //id,tipo,usuariocamara,usuarioempaque,pesoporcaja,numerocajas,pesocajas,pesosaldo,pesototal,aprobado,estado,linea
    let p = new PackingEC(-1,tipo,1,encargadoempaque,nt,nc,kc,ks,kt,0,1,linea);

    return p.getJson();
  }

  /**
  * Transforma un objeto a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformDataPacking(packing:any){
   console.log("PACKING OBJECT: ", packing);
   //                    id,     tipo, usuariocamara,usuarioempaque,pesoporcaja,numerocajas,pesocajas,pesosaldo,pesototal,aprobado,estado,linea
   let p = new PackingEC(-1,packing.tipo,1,packing.encargado,packing.kilos_por_caja,packing.num_cajas,packing.kilos_total_cajas,packing.kilos_total_saldos,packing.kilos_totales_packing,0,1,packing.linea);
    //console.log("Kilos Cajas: ", nc);
    //id,tipo,usuariocamara,usuarioempaque,pesoporcaja,numerocajas,pesocajas,pesosaldo,pesototal,aprobado,estado,linea
    //let p = new PackingEC(-1,tipo,1,encargadoempaque,nt,nc,kc,ks,kt,0,1,linea);

    return p.getJson();
  }

  /**
  * Transforma un objeto a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformData2(valor,id){
    //id,tipo,usuariocamara,usuarioempaque,pesoporcaja,numerocajas,pesocajas,pesosaldo,pesototal,aprobado,estado,linea
    let p = new PackingEC(id,0,0,0,0,0,0,0,0,0,valor,0);
    return p.getJson2();
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/packingec.service.ts